import { render, staticRenderFns } from "./YKDivider.vue?vue&type=template&id=66758f34&scoped=true&"
var script = {}
import style0 from "./YKDivider.vue?vue&type=style&index=0&id=66758f34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66758f34",
  null
  
)

export default component.exports